import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import { SpinLoader } from "../SpinLoader"
import { Icon, IconName } from "../../media/Icon"

export const COMPONENT_NAME = "button"

export const presets = {
  state: {
    ready: "",
    disabled: "",
  },
}

export interface Props extends Component {
  label: string
  state?: keyof typeof presets.state
  icon: IconName
  onClick?: () => void
}

export function IconButton({
  label,
  state = "ready",
  onClick,
  className,
  icon,
  testId = COMPONENT_NAME,
  ...otherProps
}: Props) {
  const disabled = ["disabled"].includes(state)

  return (
    <button
      className={cx(
        `size-5 rounded-sm text-icon hover:text-icon-hover focus:text-icon-focus`,
        "transition",
        disabled && "pointer-events-none disabled:text-icon-disabled",
        !disabled && "focus-ring",
        className,
      )}
      type="button"
      onClick={onClick}
      data-test={testId}
      disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      {...otherProps}
    >
      <Icon name={icon} className="size-5" />
      <div className="sr-only">{label}</div>
    </button>
  )
}
